import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { TemplateDetail } from './types/template-detail.type';

/**
 * Inserts a new template detail using the provided HTTP client instance.
 *
 * Sends a POST request to the template detail insertion endpoint with the given data.
 *
 * @param instance - The Ky HTTP client instance to use for the request.
 * @param data - The template detail data to insert.
 * @returns A promise that resolves to the operation result of the insertion.
 * @throws Throws an error if the request fails.
 */
export const insertTemplateDetail = async (instance: KyInstance, data: TemplateDetail) => {
  try {
    return await instance.post<OperationResult>(Uri.template.insertTemplateDetail, { json: data }).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
